import React from "react";
import { MapPin, Crown } from "lucide-react";

export const MemberCellBadge = ({ info, id }) => {
  if (!info) return null;
  if (!info.group_name) {
    return <span data-testid={`member-cell-${id}`} className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full mt-1" style={{ background: "#F1F4F2", color: "var(--sj-text-3)" }}><MapPin className="h-3 w-3" /> Cell group: awaiting placement</span>;
  }
  return (
    <span data-testid={`member-cell-${id}`} title={info.status === "Approved" ? "Approved cell group" : "Draft cell group (not yet approved)"} className="inline-flex items-center gap-1 whitespace-nowrap text-[11px] font-medium px-2 py-0.5 rounded-full mt-1" style={{ background: "#E3F1EC", color: "var(--sj-primary)" }}>
      <MapPin className="h-3 w-3" /> {info.group_name}{info.status !== "Approved" ? " (draft)" : ""} · {info.is_host ? <><Crown className="h-3 w-3" style={{ color: "#D97706" }} /> Host</> : <>Host: {info.host_name}</>}
    </span>
  );
};

export const MemberCellCard = ({ info }) => (
  <div data-testid="member-cell-card" className="sm:col-span-2 rounded-xl border p-4 flex flex-wrap items-center gap-x-6 gap-y-2" style={{ borderColor: "var(--sj-border)", background: "#F7FAF8" }}>
    <div className="flex items-center gap-2 font-semibold text-sm" style={{ color: "var(--sj-primary)" }}><MapPin className="h-4 w-4" /> Cell group</div>
    {!info ? <span className="text-sm" style={{ color: "var(--sj-text-3)" }}>Not signed up for a cell group</span>
      : !info.group_name ? <span className="text-sm" style={{ color: "var(--sj-text-2)" }}>Signed up — awaiting placement</span>
      : <>
        <span className="text-sm"><span style={{ color: "var(--sj-text-3)" }}>Group:</span> <b data-testid="member-cell-card-group">{info.group_name}</b>{info.status !== "Approved" && <span className="text-xs ml-1" style={{ color: "#B45309" }}>(draft)</span>}</span>
        <span className="text-sm"><span style={{ color: "var(--sj-text-3)" }}>Host:</span> <b data-testid="member-cell-card-host">{info.is_host ? "This member" : info.host_name}</b></span>
        {info.meeting_day && <span className="text-sm"><span style={{ color: "var(--sj-text-3)" }}>Meets:</span> {info.meeting_day}</span>}
      </>}
  </div>
);
